import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  private config: any = {}

  loadConfig(): Promise<void> {
    return fetch('/assets/config.json')
      .then((res) => res.json())
      .then((data) => {
        this.config = data
      })
      .catch(() => {})
  }

  get cmsServerUrl(): string {
    console.log('config:', this.config)
    return this.config.cmsServerUrl || 'https://cms-backend.otimusclinic.com'
  }
}
